export const TTSControlReducer = (state, action) => {
  switch (action.type) {
    case 'TTS_SUPPORT_FOUND':
      return {
        ...state,
        hasTTSSupport: true,
        voices: action.voices,
        selectedVoiceIndex: action.voiceIndex,
      };
    case 'VOICE_SELECTED':
      return {
        ...state,
        selectedVoiceIndex: action.voiceIndex,
      };
    case 'PLAY':
      return {
        ...state,
        playState: 'PLAYING',
      };
    case 'PAUSE':
      return {
        ...state,
        playState: 'PAUSED',
      };
    case 'RESUME':
      return {
        ...state,
        playState: 'PLAYING',
      };
    case 'STOP':
    case 'FINISHED':
      return {
        ...state,
        playState: 'IDLE',
      };
    default:
      return state;
  }
};
